<template>
  <div>
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">
    <v-row>
      <v-col cols="6">
        <h4 class="mt-3 mb-1">Button Primary</h4>
        <ButtonPrimaryAction/>
        <h4 class="mt-3 mb-1">Button Secondary</h4>
        <ButtonSecondaryAction/>
        <h4 class="mt-3 mb-1">Button Tertiary</h4>
        <ButtonTertiaryAction/>
        <h4 class="mt-3 mb-1">Split / Edit Button</h4>
        <h5 class="mb-1">Edit: {{edit}}</h5>
        <EditButton @edit="onEdit" @save="onSave" @discard="onDiscard" v-model="edit"/>
      </v-col>
      <v-col cols="6">
        <h4 class="mt-3 mb-1">Buttons nebeneinader mit Abstand</h4>
        <ButtonPrimaryAction/>
        <ButtonSecondaryAction/>
      </v-col>
      <v-col cols="12">
        <WaitingIndicator/>
      </v-col>
      <v-col>
        <SwitchButton v-model="checkButtonChecked"/>
      </v-col>
      <v-col>
        <SwitchButtonLock v-model="checkButtonChecked"/>
      </v-col>
      <v-col>
        checkButtonChecked: {{checkButtonChecked}}
      </v-col>
    </v-row>


    <h2 class="text-h2 mt-5">Icons</h2>
    <v-row>
      <v-col>
        <AcceptIcon/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'
import ButtonSecondaryAction from "@/components/buttons/ButtonSecondaryAction";
import ButtonPrimaryAction from "@/components/buttons/ButtonPrimaryAction";
import ButtonTertiaryAction from "@/components/buttons/ButtonTertiaryAction";
import EditButton from "@/components/buttons/EditButton";
import WaitingIndicator from "@/components/icons/WaitingIndicator";
import SwitchButton from "@/components/buttons/templates/SwitchButton";
import SwitchButtonLock from "@/components/buttons/SwitchButtonLock";
import AcceptIcon from "../components/icons/AcceptIcon";

export default {
  name: "ButtonView",
  components: {
    AcceptIcon,
    SwitchButtonLock,
    SwitchButton,
    WaitingIndicator, EditButton, ButtonTertiaryAction, ButtonPrimaryAction, ButtonSecondaryAction},
  setup(){

    const edit = ref(false)

    function onEdit () {
      console.log('edit event')
    }

    function onSave () {
      console.log('save event')
    }

    function onDiscard () {
      console.log('discard event')
    }

    const checkButtonChecked = ref(false)

    return {
      edit,
      onEdit,
      onSave,
      onDiscard,
      checkButtonChecked
    }
  }
}
</script>

<style scoped>

</style>
